import { render, staticRenderFns } from "./ThirdPartyDetails.vue?vue&type=template&id=3c54fd00"
import script from "./ThirdPartyDetails.vue?vue&type=script&lang=js"
export * from "./ThirdPartyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports